import { PaymentWayList } from '@zurich/api/contract';
import { createArrayUtils, UnknownType } from '@zurich/common/utils';
const utils = createArrayUtils(PaymentWayList, {
    unknownType: UnknownType.STRING,
    translationPrefix: 'contract:paymentWay',
    createDefaultValue: () => 'Bankinkasso',
});
export const paymentWayUtils = {
    ...utils,
    // TODO: option to distiguish between customer/company product
    // FIRMENKONOT is not available for consumer products
    createOptions: (t) => {
        const types = ['Bankinkasso', 'Zentralinkasso'];
        return types.map((value) => utils.createOption(t, value));
    },
    createAllOptions: (t) => {
        const types = [
            'Zentralinkasso',
            'Bankinkasso',
            'Firmenkonto',
            'KKI',
        ];
        return types.map((value) => utils.createOption(t, value));
    },
};
